module.exports = " <div class=cartcontrol> <div class=cart-decrease v-show=\"food.count>0\" @click.stop.prevent=decreaseCart transition=move> <span class=\"inner icon-remove_circle_outline\"></span> </div> <div class=cart-count v-show=\"food.count>0\">{{food.count}}</div> <div class=\"cart-add icon-add_circle\" @click.stop.prevent=addCart></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cartcontrol/cartcontrol.vue
// module id = 74
// module chunks = 1